import api from 'api'
import { WageRate } from './getRule'

type UpdateRateRequest = {
  ruleId: number
  rateId: number
  hourlyRateCents?: number
  note?: string | null
  isEnabled?: boolean
}

export const updateRate = async (
  request: UpdateRateRequest
): Promise<WageRate> => {
  const response = await api.patch<WageRate>(
    `/admin/wage/rules/${request.ruleId}/rates/${request.rateId}`,
    {
      hourlyRateCents: request.hourlyRateCents,
      note: request.note,
      isEnabled: request.isEnabled,
    }
  )
  return response.data
}
